import {txt} from '../i18n/idioma';

// Nota de cada campo de Cumplimiento (Daniel, 14/10/2026): qué es y cómo se
// llena. "La carpeta" = la carpeta Compliance de Dropbox que se carga en la app.

// ── Resumen ──
export const AYUDA_RESUMEN_CUMPLIMIENTO = {
  vencidos: txt(
    'Documentos vigentes de vínculos activos cuya fecha de vencimiento ya pasó. Lo calcula la app con la fecha de hoy.',
    'Current documents of active links whose expiry date has passed. The app works it out with today’s date.',
  ),
  porVencer: txt(
    'Documentos que vencen dentro de los días de aviso de su tipo (pestaña Tipos de documento).',
    'Documents expiring within the warning days of their type (Document types tab).',
  ),
  enRevision: txt(
    'Documentos subidos a mano que esperan que otra persona los apruebe. Lo que llega al cargar la carpeta entra aprobado.',
    'Documents uploaded by hand waiting for someone else to approve them. What comes in when loading the folder is approved.',
  ),
  faltan: txt(
    'Tipos obligatorios sin documento en vínculos activos, sin contar los marcados "No aplica".',
    'Required types without a document in active links, not counting those marked "Does not apply".',
  ),
  alDia: txt(
    'Documentos vigentes que todavía no entran en sus días de aviso, o que no vencen.',
    'Current documents not yet within their warning days, or that do not expire.',
  ),
  semaforo: txt(
    'Por categoría, los vínculos activos según su peor situación: rojo = algo vencido o faltante, amarillo = algo por vencer, gris = algo en revisión, verde = todo al día.',
    'By category, active links by their worst status: red = something expired or missing, yellow = something expiring soon, grey = something under review, green = all up to date.',
  ),
  vinculo: txt(
    'Empresa o tercero con su categoría. Al cargar la carpeta sale de su carpeta "Empresa & Tercero".',
    'Company or third party with its category. When loading the folder it comes from its "Company & Third party" folder.',
  ),
  documento: txt(
    'Tipo de documento que se exige (pestaña Tipos de documento).',
    'Required document type (Document types tab).',
  ),
  situacion: txt(
    'Vencido, por vencer, en revisión, falta, al día o no aplica. La calcula la app con el último documento recibido que no fue rechazado y la fecha de hoy.',
    'Expired, expiring soon, under review, missing, up to date or does not apply. The app works it out from the latest received document that was not rejected and today’s date.',
  ),
  vence: txt(
    'Fecha de vencimiento: la escrita en el documento o, si no, la expedición (o recepción) más la vigencia en meses del tipo.',
    'Expiry date: the one written on the document or, if none, the issue (or received) date plus the type’s validity in months.',
  ),
  responsable: txt(
    'Persona a cargo de este tipo de documento; se elige en la pestaña Tipos de documento.',
    'Person in charge of this document type; chosen in the Document types tab.',
  ),
};

// ── Una categoría (matriz) ──
export const AYUDA_MATRIZ = {
  buscar: txt('Busca por el nombre del vínculo.', 'Searches by link name.'),
  soloPendientes: txt(
    'Solo los vínculos con algo vencido, faltante, por vencer o en revisión.',
    'Only links with something expired, missing, expiring soon or under review.',
  ),
  conDesactivados: txt(
    'Muestra también los vínculos desactivados, que no cuentan ni avisan.',
    'Also shows deactivated links, which do not count or warn.',
  ),
  vinculo: txt(
    'Empresa o tercero de esta categoría. En Minas son las empresas con rol exportador; en las demás se crea al cargar la carpeta, con el nombre de su carpeta "Empresa & Tercero". El punto de color es su peor situación.',
    'Company or third party in this category. In Mines they are the companies with the exporter role; in the others it is created when loading the folder, with the name of its "Company & Third party" folder. The colored dot is its worst status.',
  ),
  tipo: txt(
    'Situación de este documento en cada vínculo, con su fecha de vencimiento. Clic en la celda para ver el historial, subir una versión nueva o marcar "No aplica".',
    'Status of this document for each link, with its expiry date. Click the cell to see the history, upload a new version or mark "Does not apply".',
  ),
  activo: txt(
    'Activo: cuenta en el resumen y avisa. Al cargar la carpeta queda inactivo el vínculo sin archivos del último año; quien edita lo cambia con un clic.',
    'Active: counts in the summary and warns. When loading the folder, a link with no files from the last year is left inactive; editors change it with a click.',
  ),
  ultimo: txt(
    'Fecha de recepción del archivo más reciente del vínculo.',
    'Received date of the link’s most recent file.',
  ),
};

// ── Archivo ──
export const AYUDA_ARCHIVO = {
  buscar: txt(
    'Busca por el nombre del archivo o de su carpeta, en la carpeta abierta y todas sus subcarpetas.',
    'Searches by file or folder name, in the open folder and all its subfolders.',
  ),
  categoria: txt(
    'Clientes, proveedores, minas, aperturas de cuenta, propios u otros. Al cargar la carpeta, la app la deduce de dónde estaba el archivo; se cambia editando el vínculo.',
    'Customers, suppliers, mines, account openings, own or other. When loading the folder, the app works it out from where the file was; it is changed by editing the link.',
  ),
  tipo: txt(
    'Tipo de documento. La app lo reconoce por las palabras clave en el nombre del archivo; "Sin clasificar" = no lo reconoció.',
    'Document type. The app recognizes it by the keywords in the file name; "Unclassified" = it did not recognize it.',
  ),
  vencimiento: txt(
    'Solo los vencidos, o solo los que vencen en los próximos 60 días.',
    'Only the expired ones, or only those expiring in the next 60 days.',
  ),
  nombre: txt(
    'Nombre del archivo como estaba en la carpeta, con su vínculo, subcarpeta (Documents, Formats, ID-Passports, Templates) y tamaño. Clic para descargarlo; la descarga queda en la bitácora.',
    'File name as it was in the folder, with its link, subfolder (Documents, Formats, ID-Passports, Templates) and size. Click to download it; the download is recorded in the audit log.',
  ),
  tipoColumna: txt(
    'Tipo de documento reconocido por las palabras clave del nombre. Quien edita lo cambia aquí; los formatos y plantillas no llevan tipo.',
    'Document type recognized by the keywords in the name. Editors change it here; forms and templates have no type.',
  ),
  recibido: txt(
    'Fecha de recepción: la que trae el nombre del archivo (2025-07-24, 24-07-2025…) o, si no trae, la de su última modificación; en lo subido a mano, la escrita al subirlo.',
    'Received date: the one in the file name (2025-07-24, 24-07-2025…) or, if none, its last modified date; for files uploaded by hand, the one entered when uploading.',
  ),
  vence: txt(
    'Expedición (o recepción) más la vigencia en meses del tipo, o la fecha escrita a mano. Vacío = no vence.',
    'Issue (or received) date plus the type’s validity in months, or the date entered by hand. Empty = does not expire.',
  ),
  situacion: txt(
    'Vencido, por vencer o al día según la fecha de hoy y los días de aviso del tipo. "Historial" = una versión anterior, que ya no avisa.',
    'Expired, expiring soon or up to date according to today’s date and the type’s warning days. "History" = an older version, which no longer warns.',
  ),
};

// ── Panel de un documento ──
export const AYUDA_DOCUMENTO = {
  recibido: txt(
    'Día en que llegó el documento. Vacía = hoy. No puede ser una fecha futura.',
    'Day the document arrived. Empty = today. It cannot be a future date.',
  ),
  expedido: txt(
    'Fecha de expedición que trae el documento. Si la escribes, la vigencia se cuenta desde ella.',
    'Issue date on the document. If you enter it, the validity is counted from it.',
  ),
  vence: txt(
    'Escríbela si el documento la trae; vacía, se calcula con la vigencia del tipo (o no vence si el tipo no tiene vigencia).',
    'Enter it if the document has one; if empty, it is calculated with the type’s validity (or it does not expire if the type has none).',
  ),
  referencia: txt(
    'Número del documento, por ejemplo el de la póliza o del certificado.',
    'Document number, for example the policy or certificate number.',
  ),
  notas: txt('Notas libres del documento.', 'Free notes about the document.'),
  carpeta: txt(
    'Ruta donde estaba el archivo dentro de la carpeta Compliance.',
    'Path where the file was inside the Compliance folder.',
  ),
  corregirRecibido: txt(
    'Fecha en que se recibió. Si la cambias sin tocar el vencimiento, el vencimiento se recalcula con la vigencia del tipo.',
    'Date it was received. If you change it without touching the expiry, the expiry is recalculated with the type’s validity.',
  ),
  corregirVence: txt('Fecha real de vencimiento; vacía = no vence.', 'Actual expiry date; empty = does not expire.'),
  notaDeRevision: txt(
    'Comentario de quien revisa; obligatorio para rechazar. Queda en el historial.',
    'Reviewer’s comment; required to reject. It stays in the history.',
  ),
};

// ── Editar un vínculo ──
export const AYUDA_VINCULO = {
  nombre: txt(
    'Nombre del vínculo; al cargar la carpeta sale del nombre de su carpeta.',
    'Link name; when loading the folder it comes from its folder name.',
  ),
  categoria: txt(
    'Categoría del vínculo. Al cambiarla, sus documentos se vuelven a reconocer con los tipos de la nueva.',
    'Link category. When changed, its documents are recognized again with the types of the new one.',
  ),
  seccion: txt(
    'Carpeta principal donde está (Compliance Colombia, Compliance Internacional…); agrupa las filas en la categoría.',
    'Main folder it is in (Compliance Colombia, Compliance Internacional…); it groups the rows in the category.',
  ),
  internacional: txt(
    'Marcado, se le piden los equivalentes del exterior de cada tipo. Al cargar la carpeta se marca solo si es cliente o está en Compliance Internacional.',
    'When checked, the foreign equivalents of each type are requested. When loading the folder it is checked only for customers or links in Compliance Internacional.',
  ),
  notas: txt('Notas libres del vínculo.', 'Free notes about the link.'),
  unir: txt(
    'Vínculo que se queda con los documentos de este; este desaparece.',
    'Link that keeps this one’s documents; this one disappears.',
  ),
};

// ── Tipos de documento ──
export const AYUDA_TIPOS = {
  documento: txt(
    'Nombre del tipo de documento que se exige en esta categoría.',
    'Name of the document type required in this category.',
  ),
  equivalente: txt(
    'Nombre que tiene para una empresa del exterior (por ejemplo, Tax ID en vez de RUT). Vacío = el mismo.',
    'Name it has for a foreign company (for example, Tax ID instead of RUT). Empty = the same.',
  ),
  obligatorio: txt(
    'Si falta en un vínculo activo, cuenta como "Falta".',
    'If it is missing in an active link, it counts as "Missing".',
  ),
  vigencia: txt(
    'Meses que dura desde la expedición o la recepción. Vacía = no vence (la fecha se escribe en el documento).',
    'Months it lasts from issue or receipt. Empty = does not expire (the date is written on the document).',
  ),
  aviso: txt(
    'Cuántos días antes del vencimiento empieza a salir "Por vencer".',
    'How many days before expiry it starts showing "Expiring soon".',
  ),
  responsable: txt(
    'Persona a cargo de este documento; sale en los avisos del resumen.',
    'Person in charge of this document; shown in the summary warnings.',
  ),
  palabras: txt(
    'Palabras que reconocen el tipo en el nombre del archivo al cargar la carpeta, separadas por comas. Si varias coinciden, gana la más larga.',
    'Words that recognize the type in the file name when loading the folder, comma separated. If several match, the longest wins.',
  ),
  archivos: txt(
    'Cuántos archivos de este tipo hay. Lo cuenta la app.',
    'How many files of this type there are. The app counts them.',
  ),
  activo: txt(
    'Un tipo inactivo deja de exigirse y conserva sus documentos.',
    'An inactive type is no longer required and keeps its documents.',
  ),
  nuevo: txt(
    'Nombre del tipo nuevo. Entra obligatorio, con 12 meses de vigencia y 60 días de aviso; después se ajusta en la tabla.',
    'Name of the new type. It starts as required, with 12 months of validity and 60 warning days; adjust it later in the table.',
  ),
  conDesactivados: txt(
    'Muestra los tipos inactivos, por ejemplo para volver a activarlos.',
    'Shows inactive types, for example to activate them again.',
  ),
};

// ── Cargar carpeta ──
export const AYUDA_CARGA_CARPETA = {
  archivos: txt('Todos los archivos de la carpeta elegida.', 'All the files in the chosen folder.'),
  nuevos: txt(
    'Los que no están en la app o cambiaron; solo estos se suben.',
    'Those not in the app or that changed; only these are uploaded.',
  ),
  yaCargados: txt(
    'Misma ruta y mismo contenido que lo ya cargado: no se repiten.',
    'Same path and same content as what was already loaded: they are not repeated.',
  ),
  ignorados: txt(
    'Accesos directos, archivos del sistema y temporales de Office: no se cargan.',
    'Shortcuts, system files and Office temporary files: they are not loaded.',
  ),
  clasificados: txt(
    'Archivos cuyo tipo se reconoció por las palabras clave del nombre.',
    'Files whose type was recognized by the keywords in the name.',
  ),
  sinClasificar: txt(
    'Archivos sin tipo reconocido; después se les elige en el Archivo.',
    'Files with no recognized type; it is chosen later in Files.',
  ),
  formatos: txt(
    'Archivos de las subcarpetas Formats y Templates: se guardan pero no avisan.',
    'Files in the Formats and Templates subfolders: they are stored but do not warn.',
  ),
  vencimientos: txt(
    'Cuántos quedarían vencidos y cuántos por vencer con la vigencia de su tipo.',
    'How many would be expired and how many expiring soon with their type’s validity.',
  ),
  categoria: txt('Categoría que la app deduce de la carpeta.', 'Category the app works out from the folder.'),
  vinculo: txt(
    'Nombre del vínculo, tomado de su carpeta "Empresa & Tercero". "(nuevo)" = todavía no existía en la app.',
    'Link name, taken from its "Company & Third party" folder. "(new)" = it did not exist in the app yet.',
  ),
  archivosVinculo: txt('Archivos de ese vínculo en la carpeta.', 'Files of that link in the folder.'),
  queda: txt(
    'Activo si tiene archivos del último año; si no, inactivo y no avisa.',
    'Active if it has files from the last year; otherwise inactive and it does not warn.',
  ),
};

// ── Fichas de empresas: todo se escribe a mano en la ficha ──
export const AYUDA_FICHA = {
  general: txt(
    'Todos los datos se escriben a mano en esta ficha; los cambia quien tiene permiso de edición y queda la fecha y el autor de la última actualización.',
    'All the details are entered by hand in this profile; editors change them and the date and author of the last update are kept.',
  ),
  razonSocial: txt(
    'Nombre legal completo de la empresa, como en su certificado de existencia.',
    'Full legal name of the company, as on its certificate of incorporation.',
  ),
  nombreComercial: txt(
    'Nombre con que se conoce la empresa, si es distinto de la razón social.',
    'Name the company is known by, if different from the legal name.',
  ),
  tipoDeIdentificacion: txt(
    'Clase de identificación tributaria: NIT en Colombia, Tax ID u otra en el exterior.',
    'Kind of tax ID: NIT in Colombia, Tax ID or another abroad.',
  ),
  numeroDeIdentificacion: txt(
    'Número de esa identificación, con el dígito de verificación si lo tiene.',
    'Number of that ID, with the check digit if it has one.',
  ),
  fechaDeConstitucion: txt('Fecha en que se constituyó la empresa.', 'Date the company was incorporated.'),
  actividadEconomica: txt('A qué se dedica la empresa.', 'What the company does.'),
  codigoCiiu: txt(
    'Código de la actividad económica (CIIU), como aparece en el RUT.',
    'Business activity code (CIIU), as shown in the RUT.',
  ),
  direccion: txt('Dirección principal de la empresa.', 'Main address of the company.'),
  ciudad: txt('Ciudad de esa dirección.', 'City of that address.'),
  pais: txt('País de esa dirección.', 'Country of that address.'),
  codigoPostal: txt('Código postal de esa dirección.', 'Postal code of that address.'),
  telefono: txt('Teléfono principal de la empresa.', 'Main phone number of the company.'),
  correo: txt('Correo principal de la empresa.', 'Main email of the company.'),
  sitioWeb: txt('Página web de la empresa.', 'Company website.'),
  persona: txt(
    'Datos de la persona en este cargo, tal como los piden los formularios: nombre, documento, nacionalidad, cargo y contacto.',
    'Details of the person in this role, as forms ask for them: name, ID, nationality, position and contact.',
  ),
  tipoDeDocumento: txt(
    'Cédula, pasaporte u otro documento de la persona.',
    'National ID, passport or other ID of the person.',
  ),
  tarjetaProfesional: txt(
    'Número de la tarjeta profesional del contador o del revisor fiscal.',
    'Professional license number of the accountant or statutory auditor.',
  ),
  banco: txt('Banco donde la empresa recibe pagos.', 'Bank where the company receives payments.'),
  paisBanco: txt('País del banco.', 'Country of the bank.'),
  tipoDeCuenta: txt('Corriente, de ahorros u otra.', 'Checking, savings or other.'),
  numeroDeCuenta: txt('Número de la cuenta bancaria.', 'Bank account number.'),
  swift: txt(
    'Código SWIFT del banco, para recibir giros del exterior.',
    'Bank SWIFT code, to receive transfers from abroad.',
  ),
  titular: txt('A nombre de quién está la cuenta.', 'Name the account is held in.'),
  direccionBanco: txt(
    'Dirección de la sucursal del banco. Sale en las facturas al exterior (por ejemplo a Bluequest).',
    'Address of the bank branch. It shows on invoices abroad (for example to Bluequest).',
  ),
  bancoCorresponsal: txt(
    'Banco intermediario por el que llegan los giros en dólares, si lo hay. Sale en las facturas al exterior.',
    'Intermediary bank through which dollar transfers arrive, if any. It shows on invoices abroad.',
  ),
  cuentaCorresponsal: txt('Cuenta del banco corresponsal.', 'Account at the correspondent bank.'),
  swiftCorresponsal: txt(
    'SWIFT, ABA o código del banco corresponsal.',
    'SWIFT, ABA or code of the correspondent bank.',
  ),
  accionistas: txt(
    'Personas o empresas dueñas de la empresa y beneficiarios finales, con su identificación, país y porcentaje de participación.',
    'People or companies that own the company and beneficial owners, with their ID, country and ownership percentage.',
  ),
  notas: txt('Notas libres de la ficha.', 'Free notes about the profile.'),
};
